import styles from "./preloader.module.scss";

const Preloader = () => {
  return <span className={styles.preloader}></span>;
};

export default Preloader;
